import { LeaveRequest } from '../../database/tables'
import leaveRequestServiceConfigs from './configs'

export default function getFileNameFromRef(fileRef: LeaveRequest['supportingDocumentRef']): string {
  if (!!fileRef) {
    return fileRef.replace(leaveRequestServiceConfigs.collectionName, '')
  }
  return ''
}
